module.exports = __webpack_public_path__ + "static/media/bennet.192b3015.svg";